import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Paper } from "@material-ui/core";
import { getProjectResolution } from "../../services/projectFileServices";
import "react-dropzone-uploader/dist/styles.css";

const PanelFilesResolucionI = ({ projectSlug }) => {
  //RESOLUCIÓN

  let [resolution1, setResolution1] = useState(null);
  let [resolution2, setResolution2] = useState(null);
  let [resolution3, setResolution3] = useState(null);
  let [resolution4, setResolution4] = useState(null);
  let [resolution5, setResolution5] = useState(null);
  let [resolution6, setResolution6] = useState(null);
  let [resolution7, setResolution7] = useState(null);
  let [resolution8, setResolution8] = useState(null);
  let [resolution9, setResolution9] = useState(null);
  let [resolution10, setResolution10] = useState(null);

  const handleOpenPDF1 = (event) => {
    event.preventDefault();
    if (resolution1 !== null) window.open(resolution1);
  };

  const handleOpenPDF2 = (event) => {
    event.preventDefault();
    if (resolution2 !== null) window.open(resolution2);
  };

  const handleOpenPDF3 = (event) => {
    event.preventDefault();
    if (resolution3 !== null) window.open(resolution3);
  };
  const handleOpenPDF4 = (event) => {
    event.preventDefault();
    if (resolution4 !== null) window.open(resolution4);
  };
  const handleOpenPDF5 = (event) => {
    event.preventDefault();
    if (resolution5 !== null) window.open(resolution5);
  };
  const handleOpenPDF6 = (event) => {
    event.preventDefault();
    if (resolution6 !== null) window.open(resolution6);
  };
  const handleOpenPDF7 = (event) => {
    event.preventDefault();
    if (resolution7 !== null) window.open(resolution7);
  };
  const handleOpenPDF8 = (event) => {
    event.preventDefault();
    if (resolution8 !== null) window.open(resolution8);
  };
  const handleOpenPDF9 = (event) => {
    event.preventDefault();
    if (resolution9 !== null) window.open(resolution9);
  };
  const handleOpenPDF10 = (event) => {
    event.preventDefault();
    if (resolution10 !== null) window.open(resolution10);
  };

  useEffect(() => {
    const populateResolution = async () => {
      const { data: project } = await getProjectResolution(projectSlug);
      //setResolution(project.resolution);
      setResolution1(project.resolution1);
      setResolution2(project.resolution2);
      setResolution3(project.resolution3);
      setResolution4(project.resolution4);
      setResolution5(project.resolution5);
      setResolution6(project.resolution6);
      setResolution7(project.resolution7);
      setResolution8(project.resolution8);
      setResolution9(project.resolution9);
      setResolution10(project.resolution10);
    };

    populateResolution();
  }, [projectSlug]);

  return (
    <>
      <Paper className="paper">
        <h2>Resolución: </h2>

        {resolution1 === null ? (
          " No existe ningun archivo  "
        ) : (
          <Link to="#" onClick={handleOpenPDF1}>
            {resolution1 === null
              ? "No existe ningun archivo "
              : "Abrir Resolución 1"}
          </Link>
        )}

        <small style={{ color: "white" }}>
          <br />
        </small>

        {resolution2 === null ? (
          "  "
        ) : (
          <Link to="#" onClick={handleOpenPDF2}>
            {resolution2 === null ? "  " : "Abrir Resolución 2"}
          </Link>
        )}

        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution3 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF3}>
            {resolution3 === null ? "  " : "Abrir Resolución 3"}
          </Link>
        )}

        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution4 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF4}>
            {resolution4 === null ? "  " : "Abrir Resolución 4"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution5 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF5}>
            {resolution5 === null ? "  " : "Abrir Resolución 5"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution6 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF6}>
            {resolution6 === null ? "  " : "Abrir Resolución 6"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution7 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF7}>
            {resolution7 === null ? "  " : "Abrir Resolución 7"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution8 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF8}>
            {resolution8 === null ? "  " : "Abrir Resolución 8"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution9 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF9}>
            {resolution9 === null ? " " : "Abrir Resolución 9"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {resolution10 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF10}>
            {resolution10 === null ? "  " : "Abrir Resolución 10"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>
      </Paper>
    </>
  );
};

export default PanelFilesResolucionI;
